export default "__VITE_ASSET__BL08o$sg__"